/** WizardStepSource — krok 2/6 kreatora widgetu: wybór źródła danych. */

import { useTranslation } from 'react-i18next';

import { Dropdown } from '@/components/Dropdown';
import { Spinner } from '@/components/Spinner';
import type { WidgetSourceMeta } from '@/lib/widgets/types';

export interface WizardStepSourceProps {
  sources: WidgetSourceMeta[];
  loading: boolean;
  value: string | null;
  onChange: (next: string) => void;
}

export function WizardStepSource({ sources, loading, value, onChange }: WizardStepSourceProps) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-text-secondary" htmlFor="widget-wizard-source">
        {t('tenant.widgets.wizard.source.label')}
      </label>
      <Dropdown
        id="widget-wizard-source"
        value={value ?? ''}
        onChange={onChange}
        placeholder={t('tenant.widgets.wizard.source.placeholder')}
        options={sources.map((s) => ({
          value: s.key,
          label: t(`tenant.widgets.sources.${s.key}`),
        }))}
        data-testid="widget-wizard-source-select"
      />
      <p className="text-xs text-text-muted">{t('tenant.widgets.wizard.source.hint')}</p>
    </div>
  );
}
